export interface DeliveryReviewsTemplate {
  anonymousRadio: AnonymousRadio;
  deliveryIcon: string;
  guideWord: string;
  satisfiedCheck: SatisfiedCheck;
  dissatisfiedCheck: SatisfiedCheck;
}

export interface AnonymousRadio {
  isDisable: boolean;
  name: string;
  /** 0不匿名 1匿名 */
  defaultValue: number;
}

export interface SatisfiedCheck {
  name: string;
  /** 分数：1不满意 5满意 */
  score: number;
  guideWord: string;
  commentLabelList: CommentLabelItem;
}

export enum ProductClickType {
  CLICK_DEFAULT = 0,
  CLICK_LIKE = 1,
  CLICK_UNLIKE = 2
}

export enum CommentLabelType {
  UNSELECTED = 0,
  SELECTED = 1
}

export interface CommentLabelItem {
  code: number;
  name: string;
  selected?: number; //是否选中，0-未选中，1-已选中
}

export interface shopReviewsTemplate {
  anonymousRadio: number;
  picture: string;
  shopName: string;
  guideWord: string;
  skuList: any[];
  scoreStarList: ScoreStarList[];
  clickProductList: ReviewsProduct[];
}

export interface ScoreStarList {
  title: string;
  score: number;
  isShowCommentButton: number;
  commentButtonText: string;
  commentTips: string;
  ref?: any;
}
export interface SubmitData {
  orderViewId: number; //订单id
  shopId: number; // 门店Id
  anonymousToDelivery: number; //是否对骑手匿名：0否 1是
  deliveryCommentScore: number; //配送评价星级，满意5分，不满意1分
  deliveryCommentScoreDesc: string; //配送评价星级（订单完成页需要）
  commentLabelList: CommentLabelList[]; //评价标签集合
  orderCommentScore: number; //订单总体评价星级，1～5分
  orderCommentScoreDesc: string; // 订单总体评价星级文案（订单完成页需要）
  comment: string; //评价文案
  anonymousToShop: number; //是否对门店匿名：0否 1是
  shopCommentLabelList: CommentLabelItem[]; // 门店评价
  clickProductList: ReviewsProduct[]; //点踩商品
  reviewPicList: string[]; // 评论图片
  reviewCourierText: string; // 骑手评价文案
}

interface CommentLabelList {
  code: number; //评价标签编码
  name: string; //评价标签名称
}
export interface ReviewScoreVO {
  score: number;
  startIndex: number;
  guideWord: string;
  allCommentLabelList: CommentLabelItem[];
  showingCommentLabelList: CommentLabelItem[];
}

export interface ReviewsProduct {
  spuId: number;
  name: string;
  clickType: number; //0初始化 1点赞 2点踩
}
